import { render, staticRenderFns } from "./RevenueExpenses.vue?vue&type=template&id=ddf80d86&scoped=true&"
import script from "./RevenueExpenses.vue?vue&type=script&lang=js&"
export * from "./RevenueExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf80d86",
  null
  
)

export default component.exports